export const ACCEPT_APPRAISER_FILE_TYPES = 'application/pdf';
export const MAX_APPRAISER_FILE_SIZE = 100 * 1024 * 1024;
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
export const ACCEPT_IMAGE_FILE_TYPES = 'image/png,image/jpeg,image/jpg';
export const MAX_PDF_SIZE = 50 * 1024 * 1024;

export const MAX_RATE_RESTRICTION_PERIOD = 6;
export const MAX_CONDITION_RESTRICTION_PERIOD = 12;
